import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/saved_searches'
import * as AppActions from 'actions/app'

const hasFeedId = payload => Boolean(payload && typeof payload.get === 'function' && payload.get('id'))

export const initialState = fromJS({
  dialogFeed: null,
  saving: false,
  deleting: false,
  creating: false
})

export default handleActions({
  [Actions.showSavedSearchFeedDialog]: (state, { payload }) => state.set('dialogFeed', payload || null),
  [Actions.hideSavedSearchFeedDialog]: state => state.set('dialogFeed', null),

  [Actions.saveSavedSearchFeedStart]: (state, { payload }) => (
    state.set(hasFeedId(payload) ? 'saving' : 'creating', true)
  ),
  [Actions.saveSavedSearchFeedSuccess]: state => (
    state.merge({
      saving: false,
      creating: false,
      dialogFeed: null
    })
  ),
  [Actions.saveSavedSearchFeedError]: state => (
    state.merge({
      saving: false,
      creating: false
    })
  ),

  [Actions.deleteSavedSearchFeedStart]: state => state.set('deleting', true),
  [Actions.deleteSavedSearchFeedSuccess]: (state, { payload: id }) => state
    .set('deleting', false)
    .update('dialogFeed', openFeed => (
      openFeed && openFeed.get('id') === id ? null : openFeed
    )),
  [Actions.deleteSavedSearchFeedError]: state => state.set('deleting', false),

  [AppActions.resetState]: () => initialState
}, initialState)
